import { render, staticRenderFns } from "./Learn__Section__Frame.vue?vue&type=template&id=12f33750&lang=pug&"
import script from "./Learn__Section__Frame.vue?vue&type=script&lang=js&"
export * from "./Learn__Section__Frame.vue?vue&type=script&lang=js&"
import style0 from "./Learn__Section__Frame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports